<div class="card">
  <div class="card-body">
    <app-translated-desc [(data)]="Item.transaltedobjects" [col4]="true"></app-translated-desc>
    <div class="form-actions m-t-40">
      <button type="submit" class="btn btn-success" (click)="saveClick()">
        <i class="fa fa-check"></i> {{'prodotti.Save' | translate}}</button>
      <button type="button" class="btn btn-dark" (click)="cancel()">{{'prodotti.cancel' | translate}}</button>
    </div>
  </div>
</div>
